import { fetchStaffRegulatorsList } from "./useStaffRegulatorsList";
import type { StaffRegulator } from "./types";

export const CREATE_STAFF_REGULATOR_POLL_MS = 500;

type WaitDeps = {
  fetchList: typeof fetchStaffRegulatorsList;
  now: () => number;
  sleep: (ms: number) => Promise<void>;
};

const defaultDeps: WaitDeps = {
  fetchList: fetchStaffRegulatorsList,
  now: () => Date.now(),
  sleep: (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
};

export const waitForCreatedStaffRegulator = async (
  email: string,
  deadlineMs: number,
  deps: Partial<WaitDeps> = {},
): Promise<StaffRegulator | null> => {
  const { fetchList, now, sleep } = { ...defaultDeps, ...deps };
  const needle = email.trim().toLowerCase();
  while (now() < deadlineMs) {
    try {
      const match = (await fetchList()).find(
        (row) => row.email.toLowerCase() === needle,
      );
      if (match) {
        return match;
      }
    } catch {
      // List can 504 the same way; keep polling until the client cap.
    }
    if (now() >= deadlineMs) {
      break;
    }
    await sleep(CREATE_STAFF_REGULATOR_POLL_MS);
  }
  return null;
};
